import { networks } from "./supported-networks";

// TODO: remove it
export const getNetworkName = (networkCode: string, networkName = networkCode) => {
  let knownNetwork;

  for (const network of networks) {
    // Test if the string matches the network's regex
    if (network.regex.test(networkCode)) {
      // Reset lastIndex property of regex to 0 to ensure accurate results for successive tests
      network.regex.lastIndex = 0;
      knownNetwork = network;
      break;
    }
  }

  if (knownNetwork) {
    return knownNetwork.name;
  }

  return networkName.toUpperCase();
};
export * from "./supported-networks";
